// ✅ src/components/AssigneeDropdown.jsx
import { useState, useEffect } from "react";
import { MenuItem, FormControl, Select, InputLabel } from "@mui/material";
import { CHIP_FONT_SIZE } from "../theme/constants";

// ✅ Centralized base URL with fallback
const BASE_URL = process.env.REACT_APP_BASE_URL ?? "";

/**
 * Dropdown for selecting ticket assignee.
 * Props:
 * - ticket: entire ticket object (includes id and assigned_to)
 * - onChange: callback when assignee changes
 */
const AssigneeDropdown = ({ ticket, onChange }) => {
  const [assignee, setAssignee] = useState(ticket.assigned_to || "");
  const [users, setUsers] = useState([]);

  useEffect(() => {
    setAssignee(ticket.assigned_to || "");
  }, [ticket.assigned_to]);

  useEffect(() => {
    const fetchUsers = async () => {
      try {
        const res = await fetch(`${BASE_URL}/auth/users`, {
          credentials: "include",
        });
        const data = await res.json();
        setUsers(data.filter((u) => u.email && u.name)); // filter out incomplete users
      } catch (err) {
        console.error("Failed to fetch users:", err);
      }
    };

    fetchUsers();
  }, []);

  const handleChange = (event) => {
    const selected = event.target.value;
    if (selected === assignee) return;
    setAssignee(selected);
    onChange && onChange(selected);
  };

  if (!ticket?.id) return null;

  const emailOptions = users.map((u) => u.email);
  const valueIsValid = assignee === "" || emailOptions.includes(assignee);

  return (
    <FormControl
      fullWidth
      size="small"
      sx={{ "& .MuiInputBase-root": { fontSize: CHIP_FONT_SIZE } }}
    >
      <InputLabel sx={{ fontSize: CHIP_FONT_SIZE }}>Assign</InputLabel>
      <Select
        value={valueIsValid ? assignee : ""}
        label="Assign"
        onChange={handleChange}
        sx={{ fontSize: CHIP_FONT_SIZE }}
      >
        <MenuItem value="" sx={{ fontSize: CHIP_FONT_SIZE }}>None</MenuItem>
        {users.map((user) => (
          <MenuItem
            key={user.email}
            value={user.email}
            sx={{ fontSize: CHIP_FONT_SIZE }}
          >
            {user.name}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
};

export default AssigneeDropdown;